<template>
  <NavMenu />
  <section class="border-t">
    <div class="bg-brand-blue py-8 px-5">
      <div class="max-w-7xl mx-auto">
        <div class="text-white">
          <div class="">
            <div class="text-sm font-bold text-gray-200 mb-5">
              Home / reporting
            </div>
            <h1 class="text-3xl font-bold">Protocols</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="py-20">
      <div class="max-w-7xl mx-auto">
        <div>
          <div class="grid lg:grid-cols-3 gap-8">
            <template v-for="(row, i) in docs" :key="i">
              <div
                class="
                  flex
                  space-x-3
                  p-5
                  rounded-xl
                  bg-gray-50
                  hover:bg-gray-100
                  transition-all
                "
                v-if="row.isPublished"
              >
                <div><DocumentTextIcon class="w-6 h-6" /></div>
                <div>
                  <div class="font-bold text-lg">
                    {{ row.name }}
                  </div>
                  <div class="text-gray-500 text-sm mb-1">
                    {{ row.description }}
                  </div>
                  <div v-if="row.pdfUrl">
                    <a :href="row.pdfUrl" class="link">Download file</a>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
  <SectionFooter />
</template>

<script setup>
import NavMenu from "@/components/NavMenu";
import { DocumentTextIcon } from "@heroicons/vue/outline";
import SectionFooter from "@/components/SectionFooter";
import { useStore } from "vuex";
import { computed, onMounted } from "@vue/runtime-core";

const store = useStore();
const docs = computed(() => store.getters["requestType/data"].rows);

onMounted(() => {
  document.title = "Protocols - The Coral Database";
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", "Protocols at the Coral Database");
});

function init() {
  store.dispatch("http/send", {
    module: "requestType",
    params: {
      serviceTypeCategoryId: 1,
    },
  });
  store.dispatch("http/send", {
    module: "atoll",
  });
}
init();
/* 
const docs = [
  {
    name: "Coral Spawning",
    link: "#",
    txt: "Protocol to collect PQ images on a transect",
  },
  {
    name: "Coral Bleaching",
    link: "#",
    txt: "Protocol to collect PQ images without a transect",
  },
  {
    name: "Marine Animal Sighting & Stranding",
    link: "#",
    txt: "Protocol to collect to information about the coral reef benthos using a point intercept transect",
  },
  {
    name: "Fish Kills & Stranding",
    link: "#",
    txt: "Guidance to collect aerial imagery to report coral bleaching and coral spawning events",
  },
]; */
</script>